import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import { PageTitle } from '../../../../_metronic/layout/core';
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
import DatePickerYear from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import SelectList from '../../../Components/Select/SelectList';
import AgTable from '../../../Components/Table/AgTable';

export default function RankingVentas({ title }) {

    const [date, setDate] = useState(new Date());
    let dateFormated = Utilities.formaterDate(date);
    registerLocale('es', es);

    const animatedComponents = makeAnimated();

    const [unidadEconomica, setUnidadEconomica] = useState(Utilities.getListUnidadesEconomicas().list[0]);
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();

    const [searchCebe, setSearchCebe] = useState(false)
    const [refreshCebe, setRefreshCebe] = useState(false)
    const [cebe, setCebe] = useState(null)
    const [tipoRanking, setTipoRanking] = useState({
        "value": "rankingMensual",
        "label": "Mensual de Ventas"
    });
    let tipoRankingList = {
        "defaultId": "rankingMensual",
        "list": [
            {
                "value": "rankingMensual",
                "label": "Mensual de Ventas"
            },
            {
                "value": "rankingAnual",
                "label": "Anual de Ventas"
            },
            {
                "value": "rankingAnualM2",
                "label": "Anual de Ventas por M2"
            }]
    };


    const getOptionValueUnidadEconomica = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }

    const onChangeUnidadEconomica = (inputValue) => {
        setUnidadEconomica(inputValue);
        setSearchCebe(true)
    }

    const getOptionValueTipoRanking = idDefault => {
        return tipoRankingList.list.filter(obj => obj.value === idDefault)
    }

    const onChangeTipoRanking = (inputValue) => {
        setTipoRanking(inputValue);
    }

    const onChangeCebe = (inputValue) => {
        setCebe(inputValue);
        setRefreshCebe(true)
    }


    let headerMensual = [
        {
            headerName: 'Ranking',
            field: 'ranking',
            type: 'rightAligned',
        },
        {
            headerName: 'Cod Contrato',
            field: 'codigoContrato',
            type: 'rightAligned',
        },
        {
            headerName: 'Den Contrato',
            field: 'denContrato',
        },
        {
            headerName: 'Objetos',
            field: 'objetos',
        },
        {
            headerComponent: () => (<span>Area (m <sup>2</sup>)</span>),
            field: 'area',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.area, 4)}</>
            )
        },
        {
            headerName: 'Monto de Venta (S/)',
            field: 'montoVenta',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.montoVenta, 2)}</>
            )
        },
        {
            headerName: 'Transacciones',
            field: 'transacciones',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.transacciones, false)}</>
            )
        },
        {
            headerName: 'Cod Rubro',
            field: 'codRubro',
        },
        {
            headerName: 'Rubro',
            field: 'rubro',
        },
        {
            headerName: 'Cod CEBE',
            field: 'codCebe',
        },
        {
            headerName: 'CEBE',
            field: 'cebe',
        },
        {
            headerName: 'Comercial',
            field: 'comercial',
        }
    ];

    let headerAnual = [
        {
            headerName: 'Contrato',
            field: 'contrato',
            type: 'rightAligned',
        },
        {
            headerName: 'Nombre Fant',
            field: 'nombreFantasia',
        },
        {
            headerName: 'Objetos',
            field: 'objetos',
        },
        {
            headerComponent: () => (<span>Area (m <sup>2</sup>)</span>),
            field: 'area',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.area, true, 4)}</>
            )
        },
        {
            headerName: 'Cod Rubro',
            field: 'codRubro',
        },
        {
            headerName: 'Rubro',
            field: 'rubro',
        },
        {
            headerName: 'Cod CEBE',
            field: 'codCebe',
        },
        {
            headerName: 'CEBE',
            field: 'cebe',
        },
        {
            headerName: 'Comercial',
            field: 'comercial',
        }
    ];

    let headerAnualM2 = [
        {
            headerName: 'Contrato',
            field: 'contrato',
            type: 'rightAligned',
        },
        {
            headerName: 'Nombre Fant',
            field: 'nombreFantasia',
        },
        {
            headerName: 'Objetos',
            field: 'objetos',
        },
        {
            headerComponent: () => (<span>Area (m <sup>2</sup>)</span>),
            field: 'area',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.area, true, 4)}</>
            )
        },
        {
            headerName: 'Cod Rubro',
            field: 'codRubro',
        },
        {
            headerName: 'Rubro',
            field: 'rubro',
        },
        {
            headerName: 'Cod CEBE',
            field: 'codCebe',
        },
        {
            headerName: 'CEBE',
            field: 'cebe',
        },
        {
            headerName: 'Comercial',
            field: 'comercial',
        }
    ];

    const curretDate = new Date();
    Utilities.monthFullNames.forEach(function (monthFullName, index, array) {
        if (index < (curretDate.getMonth() + 1) || date.getFullYear() < curretDate.getFullYear()) {
            headerAnual.push({
                headerName: monthFullName.charAt(0).toUpperCase() + monthFullName.slice(1) + " (S/)",
                field: monthFullName.toLocaleLowerCase(),
                type: 'rightAligned',
                cellRenderer: (props) => (
                    <>{Utilities.comillasFix(props.data[monthFullName.toLocaleLowerCase()], true, 2)}</>
                )
            });
            headerAnualM2.push({
                headerName: monthFullName.charAt(0).toUpperCase() + monthFullName.slice(1) + " (S/)",
                field: monthFullName.toLocaleLowerCase(),
                type: 'rightAligned',
                cellRenderer: (props) => (
                    <>{Utilities.comillasFix(props.data[monthFullName.toLocaleLowerCase()], true, 2)}</>
                )
            });
        }
    });
    headerAnual.push({
        headerName: 'Total (S/)',
        field: 'total',
        type: 'rightAligned',
        cellRenderer: (props) => (
            <>{Utilities.comillasFix(props.data.total, true, 2)}</>
        )
    });
    headerAnualM2.push({
        headerName: 'Total Promedio (S/)',
        field: 'total',
        type: 'rightAligned',
        cellRenderer: (props) => (
            <>{Utilities.comillasFix(props.data.total, true, 2)}</>
        )
    });

    const token = useGetToken();

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.RANKING_VENTAS]} >
                <PageTitle>{title}</PageTitle>
                <div className="d-flex flex-wrap flex-stack mb-6">

                    <h3 className="fw-bolder my-2">Tipo de Ranking
                    </h3>

                    <div className="d-flex flex-wrap my-2">
                        <div className="me-4" style={{ minWidth: "200px" }}>
                            <Select
                                classNamePrefix='filter'
                                components={animatedComponents}
                                defaultValue={getOptionValueTipoRanking(tipoRankingList.defaultId)}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                options={tipoRankingList.list}
                                onChange={(onChangeTipoRanking)}
                            />
                        </div>
                    </div>

                </div>

                <div className="card my-5">
                    <div className="card-header border-0 pt-6 row g-3 flex-wrap d-flex flex-row">
                        
                        <div className='col-12 col-sm-4 '>
                            {tipoRanking.value === "rankingMensual" ?
                                (
                                    <>
                                        <div className="fw-bold fs-7 text-gray-600 mb-1">Mes:</div>
                                        <DatePickerYear
                                            className="form-control form-control-transparent pe-5"
                                            locale="es"
                                            selected={date}
                                            onChange={(dateX) => dateX && setDate(dateX)}
                                            dateFormat="MM/yyyy"
                                            showMonthYearPicker
                                            maxDate={new Date()}
                                        />
                                    </>
                                ) :
                                (
                                    <>
                                        <div className="fw-bold fs-7 text-gray-600 mb-1">Año:</div>
                                        <DatePickerYear
                                            className="form-control form-control-transparent pe-5"
                                            locale="es"
                                            selected={date}
                                            onChange={(dateX) => dateX && setDate(dateX)}
                                            dateFormat="yyyy"
                                            showYearPicker
                                        />
                                    </>
                                )
                            }
                        </div>

                        <div className="col-12 col-sm-4 ">
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                            <Select
                                components={animatedComponents}
                                defaultValue={getOptionValueUnidadEconomica(unidadesEconomicasList.defaultId)}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                options={unidadesEconomicasList.list}
                                onChange={(onChangeUnidadEconomica)}
                            />
                        </div>

                        <div className="col-12 col-sm-4 ">
                            <SelectList
                                title="CeBe"
                                classNamePrefix='filter'
                                apiService={Api.ListaCebe}
                                args={{ token: useGetToken(), unidadEconomicaId: unidadEconomica.value }}
                                conditions={true || searchCebe}
                                setConditions={setSearchCebe}
                                handleChange={onChangeCebe}
                                multiple={false}
                                defaultSetterFunction={setCebe}
                            />
                        </div>
                        

                    </div>

                    {tipoRanking.value === "rankingMensual" ?
                        <>
                            <div className="card-body tab-content pt-0">
                                {cebe &&
                                    <AgTable
                                        idContent={"RankingMensual" + date + unidadEconomica.value + tipoRanking.value + cebe.value}
                                        apiService={Api.RankingVentasMensual}
                                        setAuxData={null}
                                        header={headerMensual}
                                        titleExcel={`RankingMensual ${date.getMonth() + 1}/${date.getFullYear()} ${unidadEconomica.label}`}
                                        conditions={true || refreshCebe}
                                        args={{
                                            anio: dateFormated.split("/")[2],
                                            mes: dateFormated.split("/")[1],
                                            token: token,
                                            unidadEconomica: unidadEconomica.value,
                                            rubroId: cebe.value
                                        }}
                                        hideFilter={false}
                                        paginationPageSize={8}
                                        rowHeight={40}
                                        useFlex = {false}
                                    />
                                }
                            </div>
                        </>
                        :
                        tipoRanking.value === "rankingAnual" ?
                            <>
                                <div className="card-body tab-content pt-0">
                                    {cebe &&
                                        <AgTable
                                            idContent={"RankingAnual" + date + unidadEconomica.value + tipoRanking.value + cebe.value}
                                            apiService={Api.RankingVentasAnual}
                                            setAuxData={null}
                                            header={headerAnual}
                                            titleExcel={"RankingAnual " + date + " " + unidadEconomica.label}
                                            conditions={true}
                                            args={{
                                                anio: dateFormated.split("/")[2],
                                                token: token,
                                                unidadEconomica: unidadEconomica.value,
                                                rubroId: (cebe?.value) ? cebe.value : null,
                                            }}
                                            hideFilter={false}
                                            paginationPageSize={8}
                                            rowHeight={40}
                                            useFlex = {false}
                                        />
                                    }
                                </div>
                            </>
                            :

                            tipoRanking.value === "rankingAnualM2" &&
                            <>
                                <div className="card-body tab-content pt-0">
                                    {cebe &&
                                        <AgTable
                                            idContent={"RankingAnualM2" + date + unidadEconomica.value + tipoRanking.value + cebe.value}
                                            apiService={Api.RankingVentasAnualM2}
                                            setAuxData={null}
                                            header={headerAnualM2}
                                            titleExcel={"RankingAnualM2 " + date + " " + unidadEconomica.label}
                                            conditions={true}
                                            args={{
                                                anio: dateFormated.split("/")[2],
                                                token: token,
                                                unidadEconomica: unidadEconomica.value,
                                                rubroId: (cebe?.value) ? cebe.value : null,
                                            }}
                                            hideFilter={false}
                                            paginationPageSize={8}
                                            rowHeight={40}
                                            useFlex = {false}
                                        />
                                    }
                                </div>
                            </>
                    }
                </div>
            </PermissionsGate>
        </>
    )
}